<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Frontispiece</a></p>
<p class="toc sub"><a href="#/front02">Copyright</a></p>
<p class="toc sub"><a href="#/front03">Dedication</a></p>
<p class="toc sub"><a href="#/front04">Introduction</a></p>
<p class="part"><a href="#/c001">PART I</a></p>
<p class="toc"><a href="#/c01">God’s Will</a></p>
<p class="toc"><a href="#/c02">The Will of the Archdiocese</a></p>
<p class="toc"><a href="#/c03">Order of Execution</a></p>
<p class="toc"><span href="#/c04" title="Link target outside of Sample">Stand and Fight</span></p>
<p class="toc"><span href="#/c05" title="Link target outside of Sample">Under Fire</span></p>
<p class="toc"><span href="#/c06" title="Link target outside of Sample">Organizing for Battle</span></p>
<p class="toc"><span href="#/c07" title="Link target outside of Sample">Send Someone from Rome</span></p>
<p class="toc"><span href="#/c08" title="Link target outside of Sample">Resistance</span></p>
<p class="toc"><span href="#/c09" title="Link target outside of Sample">Intercession</span></p>
<p class="toc"><span href="#/c10" title="Link target outside of Sample">Cooperation Was Expected</span></p>
<p class="toc"><span href="#/c11" title="Link target outside of Sample">A Final Warning</span></p>
<p class="toc"><span href="#/c12" title="Link target outside of Sample">A Meeting with the Archbishop</span></p>
<p class="toc"><span href="#/c13" title="Link target outside of Sample">Cracks in the Committee</span></p>
<p class="toc"><span href="#/c14" title="Link target outside of Sample">A Trip to Rome</span></p>
<p class="toc"><span href="#/c15" title="Link target outside of Sample">Not a Fading Parish</span></p>
<p class="toc"><span href="#/c16" title="Link target outside of Sample">Intimate Reflections</span></p>
<p class="toc"><span href="#/c17" title="Link target outside of Sample">Trying Times</span></p>
<p class="toc"><span href="#/c18" title="Link target outside of Sample">Cast Out</span></p>
<p class="part"><span href="#/c002" title="Link target outside of Sample">PART II</span></p>
<p class="toc"><span href="#/c19" title="Link target outside of Sample">Out in the Cold</span></p>
<p class="toc"><span href="#/c20" title="Link target outside of Sample">The Painful Truth Erupts</span></p>
<p class="toc"><span href="#/c21" title="Link target outside of Sample">Holding On</span></p>
<p class="toc"><span href="#/c22" title="Link target outside of Sample">Secret Plans</span></p>
<p class="toc"><span href="#/c23" title="Link target outside of Sample">A Discovery</span></p>
<p class="toc"><span href="#/c24" title="Link target outside of Sample">Dark and Light</span></p>
<p class="toc"><span href="#/c25" title="Link target outside of Sample">Yet Another Defeat</span></p>
<p class="toc"><span href="#/c26" title="Link target outside of Sample">Carrying On</span></p>
<p class="toc"><span href="#/c27" title="Link target outside of Sample">New Recruits</span></p>
<p class="toc"><span href="#/c28" title="Link target outside of Sample">New Allies</span></p>
<p class="toc"><span href="#/c29" title="Link target outside of Sample">Quiet Defiance</span></p>
<p class="toc"><span href="#/c30" title="Link target outside of Sample">Divisions</span></p>
<p class="toc"><span href="#/c31" title="Link target outside of Sample">Hope Fades</span></p>
<p class="toc"><span href="#/c32" title="Link target outside of Sample">A New Spiritual Leader</span></p>
<p class="toc"><span href="#/c33" title="Link target outside of Sample">Drawing Closer</span></p>
<p class="toc"><span href="#/c34" title="Link target outside of Sample">A Last Hurrah</span></p>
<p class="toc"><span href="#/c35" title="Link target outside of Sample">No Weepy Wake</span></p>
<p class="toc"><span href="#/c36" title="Link target outside of Sample">New Beginnings</span></p>
<p class="toc"><span href="#/c37" title="Link target outside of Sample">A Bittersweet Celebration</span></p>
<p class="toc"><span href="#/c38" title="Link target outside of Sample">“What Has the Catholic Church Done for You?”</span></p>
<p class="toc"><span href="#/c39" title="Link target outside of Sample">Another Good-bye</span></p>
<p class="part"><span href="#/c003" title="Link target outside of Sample">PART III</span></p>
<p class="toc"><span href="#/c40" title="Link target outside of Sample">An Unlikely Leader</span></p>
<p class="toc"><span href="#/c41" title="Link target outside of Sample">The Diplomat</span></p>
<p class="toc"><span href="#/c42" title="Link target outside of Sample">The Odd Couple</span></p>
<p class="toc"><span href="#/c43" title="Link target outside of Sample">The Legacy of “Big Joe”</span></p>
<p class="toc"><span href="#/c44" title="Link target outside of Sample">A D-Day of Sorts</span></p>
<p class="toc"><span href="#/c45" title="Link target outside of Sample">Not the Perfect Parent</span></p>
<p class="toc"><span href="#/c46" title="Link target outside of Sample">One Office at a Time</span></p>
<p class="toc"><span href="#/c47" title="Link target outside of Sample">A Meeting—Eight Years Later</span></p>
<p class="toc"><span href="#/c48" title="Link target outside of Sample">A Short-Lived Peace</span></p>
<p class="toc"><span href="#/c49" title="Link target outside of Sample">The Power of Prayer</span></p>
<p class="toc"><span href="#/c50" title="Link target outside of Sample">The Big Day Arrives</span></p>
<p class="toc"><span href="#/c51" title="Link target outside of Sample">Something Unusual to Propose</span></p>
<p class="toc"><span href="#/c52" title="Link target outside of Sample">Then He Got the Call</span></p>
<p class="toc"><span href="#/c53" title="Link target outside of Sample">“We Have Come a Long Way”</span></p>
<p class="toc"><span href="#/c54" title="Link target outside of Sample">Party Crashers</span></p>
<p class="toc"><span href="#/c55" title="Link target outside of Sample">Risking Arrest</span></p>
<p class="toc"><span href="#/c56" title="Link target outside of Sample">Tears of Joy</span></p>
<p class="toc"><span href="#/c57" title="Link target outside of Sample">Tragedy Strikes</span></p>
<p class="toc"><span href="#/c58" title="Link target outside of Sample">Honoring Their Leader</span></p>
<p class="toc"><span href="#/c59" title="Link target outside of Sample">Divine Discoveries</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc sub"><span href="#/back02" title="Link target outside of Sample">Author’s Note</span></p>
<p class="toc sub"><span href="#/back03" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc sub"><span href="#/back04" title="Link target outside of Sample">About the Author</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4d3e0044